var map = {
	"./level1.png": "eb92",
	"./level2.png": "00d6",
	"./level3.png": "425a",
	"./level4.png": "3d31",
	"./level5.png": "f066",
	"./level_btn_active_bg.png": "836a",
	"./level_btn_bg.png": "5fb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "690d";